import {createContext, useContext, ReactNode} from 'react';

interface ActivitySidebarContextValue {
  handleToggleTab: (tabId: string) => void;
}

const ActivitySidebarContext = createContext<ActivitySidebarContextValue | null>(null);

interface ActivitySidebarProviderProps {
  children: ReactNode;
  handleToggleTab: (tabId: string) => void;
}

export function ActivitySidebarProvider(props: ActivitySidebarProviderProps) {
  return (
    <ActivitySidebarContext.Provider value={{handleToggleTab: props.handleToggleTab}}>
      {props.children}
    </ActivitySidebarContext.Provider>
  );
}

export function useActivitySidebar(): ActivitySidebarContextValue {
  const context = useContext(ActivitySidebarContext);

  if (!context) {
    throw new Error('useActivitySidebar must be used within an ActivitySidebarProvider');
  }

  return context;
}
